module.exports = __webpack_public_path__ + "static/shotlists_notes@3x-422f5a1ab16ed5f61e9068a6fcea78be.png";